<template>
    <form :class="['registration', theme == 'black' ? s.registrationBlack : s.registrationWhite]">

        <p style="display: none;" v-if="text">{{text}}</p>
        <div :class="s.registrationContent">
            <!-- MAIN DATA-- -->
            
                <!-- EMAIL -->
                <text-input-label
                    v-model.lazy.trim="mainData.email" :placeholder="'Введите ваш email'"
                    :error="$v.mainData.email.$error">
                    Электронная почта
                    <template #bottom v-if="$v.mainData.email.$dirty">
                        <span v-if="!$v.mainData.email.required" :class="s.errorMessage">Поле обязательное</span>
                        <span v-else-if="!$v.mainData.email.emailValid" :class="s.errorMessage">Неверный email</span>
                    </template>
                </text-input-label>
                
                <!-- INN DADATA -->
                <inn-selector v-if="!showFallbackControls" :class="s.registrationInn"
                    v-model="mainData.innSelector"
                    @not-found="showFallbackControls = true"
                    @select="organizationSelect"
                    :error="$v.mainData.innSelector.$error">
                    <template v-if="$v.mainData.email.$dirty">
                        <span v-if="!$v.mainData.innSelector.required || innSelectorData.error" :class="s.errorMessage">
                            Выберите организацию
                        </span>
                    </template>
                </inn-selector>

                    <!-- Выберите организацию -->

            <!-- //MAIN DATA-- -->

            <!-- SECOND PART-- -->

                <template v-if="showFallbackControls">

                    <!-- INN MANUAL -->
                    <text-input-label :class="s.registrationInn"
                        @blur="$v.fallbackData.manualInn.$touch()"
                        v-model="fallbackData.manualInn"
                        :error="$v.fallbackData.manualInn.$error"
                        :placeholder="'Введите ИНН'">
                        ИНН
                        <template #bottom v-if="$v.fallbackData.manualInn.$dirty">
                            <span v-if="!$v.fallbackData.manualInn.required" :class="s.errorMessage">Поле обязательное</span>
                            <span v-else-if="!$v.fallbackData.manualInn.innValid" :class="s.errorMessage">Неверный ИНН</span>
                            <span v-else-if="!$v.fallbackData.manualInn.innLengthValid" :class="s.errorMessage">Неверная длинна ИНН</span>
                        </template>
                    </text-input-label>

                    <!-- Выбор между ИП и организацией -->
                    <organization-type :class="s.registrationType"
                        @select-type="isIndividual = !$event"
                        :value="!isIndividual"  />
                    
                    <!-- КПП -->
                    <text-input-label v-if="!isIndividual"
                        @blur="$v.fallbackData.kpp.$touch()"
                        v-model="fallbackData.kpp"
                        placeholder="Введите КПП"
                        :error="$v.fallbackData.kpp.$error"
                    >
                        КПП
                        <template #bottom v-if="$v.fallbackData.kpp.$dirty">
                            <span v-if="!$v.fallbackData.kpp.required" :class="s.errorMessage">Поле обязательное</span>
                            <span v-else-if="!$v.fallbackData.kpp.kppValid" :class="s.errorMessage">Неверный КПП</span>
                        </template>
                    </text-input-label>
                        
                    <!-- Название организации -->
                    <text-input-label
                        @blur="$v.fallbackData.organizationName.$touch()"
                        v-model="fallbackData.organizationName"
                        placeholder="Введите полное наименование организации"
                        :error="$v.fallbackData.organizationName.$error"
                    >
                        Полное наименование организации
                        <template #bottom v-if="$v.fallbackData.organizationName.$dirty">
                            <span v-if="!$v.fallbackData.organizationName.required" :class="s.errorMessage">Поле обязательное</span>
                        </template>
                    </text-input-label>
                    
                    <!-- ОГРН -->
                    <text-input-label
                        @blur="$v.fallbackData.ogrn.$touch()"
                        v-model="fallbackData.ogrn"
                        placeholder="Введите ОГРН"
                        :error="$v.fallbackData.ogrn.$error">
                        ОГРН
                        <template #bottom v-if="$v.fallbackData.ogrn.$dirty">
                            <span v-if="!$v.fallbackData.ogrn.required" :class="s.errorMessage">Поле обязательное</span>
                            <span v-else-if="!$v.fallbackData.ogrn.ogrnValid" :class="s.errorMessage">Неверный ОГРН</span>
                            <span v-else-if="!$v.fallbackData.ogrn.ogrnLengthValid" :class="s.errorMessage">Неверная длина огрн</span>
                        </template>
                    </text-input-label>

                </template>

            <!-- //SECOND PART-- -->

            <checkbox :class="s.registrationConfirm" @change="resetError" v-model="mainData.agreement" :theme="theme">
                <span :class="s.agreementText">
                    Я подтверждаю, что мною прочитаны, поняты и приняты<br />
                    <a :class="s.agreementLink" href="https://otc.ru/documents/trade_docs" target="_blank">Условия работы на площадке</a>
                </span>
            </checkbox>
            <span v-if="$v.mainData.agreement.$error" :class="s.agreementError">Необходимо подтвердить</span>
        </div>

        <div v-show="!isLoading" :class="[s.registrationActions, modalStyle.modalActions]">
            <button-red @click="validateAndSend" :type="'submit'" :size="'mid'">Зарегистрироваться</button-red>
        </div>

        <span v-if="registrationError" :class="s.errorMessage">{{ registrationError }}</span>
        
        <pulse-loader :class="[s.pulseLoader]" :loading="isLoading" color="#cc181e" />

        <modal :has-close="false" :class="s.modal" v-if="showSuccess" @close="showSuccess = false">
            <div style="width: 395px;">
                <div style="height: 55px;background: rgb(238, 43, 69);border-radius: 8px;font-size: 24px;line-height: 24px;text-align: center;color: rgb(255, 255, 255);vertical-align: middle;">
                    <div style="padding-top: 13px; text-align: center;">
                        Готово!
                    </div>
                </div>
                <div style="padding: 11px 16px 16px;">
                    <div style="font-size: 24px; line-height: 32px; color: black">
                        {{ successText }}
                    </div>
                    <buttonTransparent style="margin-top: 16px;" @click="onSuccess" :class="[s.buttonHover, s.grayButton]" :size="'lg'">Продолжить</buttonTransparent>
                </div>
            </div>
        </modal>
    </form>
</template>

<script>
    import Vue from 'vue'
    import { dataLoader } from '../data-loader-mixin'

    import { yandexMetrika } from '../yandex-metrika-mixin';

    import config from '@/config'

    import pulseLoader from 'vue-spinner/src/PulseLoader.vue'

    import style from './style.module.scss';
    import modalStyle from '../modal/style.module.scss'

    import inputLabel from '../inputs/text-input/input-label';
    import buttonRed from '@/components/common/click/button/button-red.vue';
    import checkbox from '../checkbox/checkbox'
    import modal from '../modal/modal'

    import organizationType from './organization-type.vue'

    import { emailValid } from '@/utils/string'
    import { validateInn, validateKpp, validateOgrn } from '@/utils/validation'

    import buttonTransparent from '../buttons/button-transparent';

    import textInput from '@/components/controls/text-input/text-input.vue'
    import textInputLabel from '@/components/controls/text-input-label/text-input-label.vue'

    import { required, between } from 'vuelidate/lib/validators'

    import innSelector from  './inn-selector/inn-selector.vue'

    const truth = (value) => value

    export default {
        name: 'registration',

        mixins: [dataLoader, yandexMetrika],

        components: {
            buttonRed,
            textInputLabel,
            checkbox,
            organizationType,
            pulseLoader,
            modal,
            buttonTransparent,
            innSelector
        },
        props: {
            theme: String,
            text: String,
            target: {
                type: String,
                default: '_self'
            },
            actionParams: {
                type: Object,
                default() {
                    return null;
                }
            },
            widgetData: null,
            noSuccessModal: {
                type: Boolean,
                required: false,
                default: false
            },
            note: {
                type: String,
                required: false,
                default: 'Зарегистрируйтесь, чтобы создать новый запрос.'
            }
        },
        data() {
            return {
                s: style,
                config: config,
                modalStyle: modalStyle,
                isIndividual: false,
                isLoading: false,
                SSOSiteUrl: process.env.VUE_APP_SSO_SITE_URL,
                showSuccess: false,
                redirectUrl: process.env.VUE_APP_COMMON_SERVICE_SITE_URL,
                registrationError: '',
                innSelectorData: {
                    inn: '',
                    kpp: '',
                    ogrn: '',
                    name: '',
                    isIndividual: false,
                    error: false
                },
                mainData: {
                    email: '',
                    innSelector: '',
                    agreement: false
                },
                fallbackData: {
                    manualInn: '',
                    kpp: '',
                    organizationName: '',
                    ogrn: '',
                },
                showFallbackControls: false
            }
        },
        validations() {
            return {
                mainData: {
                    email: {
                        required,
                        emailValid
                    },
                    innSelector: {
                        required
                    },
                    agreement: {
                        truth
                    }
                },
                fallbackData: {
                    manualInn: {
                        required,
                        innValid: validateInn,
                        innLengthValid: this.validateInnLength
                    },
                    kpp: {
                        required: this.kppRequired,
                        kppValid: (value) => validateKpp(value) || this.isIndividual
                    },
                    organizationName: {
                        required
                    },
                    ogrn: {
                        required,
                        ogrnValid: validateOgrn,
                        ogrnLengthValid: this.validateOgrnLength
                    }
                }
            }
        },
        computed: {
            content() {
                try {
                    const widgetData = this.widgetData;
                    if (widgetData) {
                        const jsonContent = widgetData.content;
                        if (jsonContent) {
                            const content = JSON.parse(jsonContent);
                            if (content) {
                                return content;
                            }
                        }
                    }
                } catch (e) {
                    /* ignore */
                }

                return null;
            },
            successText() {
                return this.content && this.content.successText || 'Мы отправили вам на почту пароль для входа в личный кабинет';
            }
        },
        methods: {
            validateInn,
            validateKpp,
            validateOgrn,
            kppRequired(value) {
                return required(value) || this.isIndividual
            },
            validateAndSend() {

                let isValid = false

                if(!this.showFallbackControls) //данные из контрола выбора инн
                {
                    this.$v.mainData.$touch();
                    isValid = this.validateDataFromInnSelector() && !this.$v.mainData.$error;
                } 
                else
                {
                    this.$v.$touch();
                    this.$v.mainData.innSelector.$reset();  //очищаем ошибки инн из контрола выбора инн

                    isValid = !this.$v.$error;
                }

                if (isValid) {
                    this.$forceUpdate();
                    this.registration(this.prepareData());
                }
            },
            validateInnLength(value) {
                if(this.isIndividual) {
                    return value.length === 12;
                }
                else
                {
                    return value.length === 10;
                }
            },
            validateOgrnLength(value) {
                if(this.isIndividual) {
                    return value.length === 15;
                }
                else
                {
                    return value.length === 13;
                }
            },
            prepareData() {

                const result = {
                    email: this.mainData.email,
                    inn: '',
                    kpp: '',
                    organizationName: '',
                    ogrn: '',
                    ogrnIP: '',
                    isPerson: false
                }

                let isIndividual = false;

                if(!this.showFallbackControls) //данные из контрола выбора инн
                {
                    isIndividual = this.innSelectorData.isIndividual;

                    result.inn              = this.innSelectorData.inn;
                    result.kpp              = this.innSelectorData.kpp;
                    result.ogrn             = isIndividual ? null : this.innSelectorData.ogrn;
                    result.ogrnIP           = isIndividual ? this.innSelectorData.ogrn : null;
                    result.organizationName = this.innSelectorData.name;
                    result.isPerson         = isIndividual
                } 
                else
                {
                    isIndividual = this.isIndividual;

                    result.inn              = this.fallbackData.manualInn;
                    result.kpp              = isIndividual ? null : this.fallbackData.kpp;
                    result.ogrn             = isIndividual ? null : this.fallbackData.ogrn;
                    result.ogrnIP           = isIndividual ? this.fallbackData.ogrn : null;
                    result.organizationName = this.fallbackData.organizationName;
                    result.isPerson         = isIndividual;
                }

                return result;

            },
            organizationSelect(response) {
                const data = response.data;
                
                if(data) {
                    this.mainData.innSelector = response.value;
                    this.innSelectorData.inn = data.inn;
                    this.innSelectorData.kpp = data.kpp;
                    this.innSelectorData.ogrn = data.ogrn;
                    this.innSelectorData.name = data.name.full;
                    this.innSelectorData.isIndividual = data.type === "INDIVIDUAL";
                }
            },
            validateDataFromInnSelector() {
                let result = true;

                if(!this.innSelectorData.inn || !validateInn(this.innSelectorData.inn)) {
                    result = false
                }

                if(!this.innSelectorData.isIndividual && (!this.innSelectorData.kpp || !validateKpp(this.innSelectorData.kpp))) {
                    result = false
                }

                if(!this.innSelectorData.ogrn || !validateOgrn(this.innSelectorData.ogrn)) {
                    result = false
                }

                if(!this.innSelectorData.name) {
                    result = false
                }

                if(!result) {
                    this.innSelectorData.error = true;
                }

                return result
            },
            registration(data) {
                const { actionParams } = this; // monitoringFilter - фильтр со страницы мониторинга
                
                this.isLoading = true;

                this.userRegistration({
                    email: data.email,
                    inn: data.inn,
                    kpp: data.kpp,
                    organizationName: data.organizationName,
                    ogrn: data.ogrn,
                    ogrnIP: data.ogrnIP,
                    isPerson: data.isPerson,
                    widgetData: {
                        touchPointInfo: this.widgetData.touchPointInfo,
                        magnetInfoId: this.widgetData.magnetInfoId,
                        content: this.widgetData.content,
                        customerparameters: actionParams ? JSON.stringify({ ...actionParams }) : null
                    },
                }, (data) => {
                    this.isLoading = false;

                    if (data.isSuccess) {
                        this.sendToYandexMetrikaRegistration();
                        this.sendToYandexMetrikaRegistrationFromSupplierFinder();
                    }

                    if (data.isSuccess === true && data.redirectUrl) {
                        if (this.noSuccessModal) {
                            this.onSuccess();
                        }
                        else {
                            this.showSuccess = true;
                        }
                        this.redirectUrl = data.redirectUrl;
                    } else {                        
                        this.registrationError = data.errorMessage != undefined ? data.errorMessage : 'Произошла ошибка при регистрации';                        
                        this.$forceUpdate();
                    }
                });
            },
            resetError() {
                this.$v.mainData.agreement.$reset();
            },
            async onSuccess() {
                if (window.eventBus) {
                    window.eventBus.$emit('auth-registration-done');
                }
                this.showSuccess = false;
                this.$emit('registered');
                await this.$store.dispatch('getUserInfo')
                this.$store.dispatch('getProjectsInfo')
            }
        }
    }
</script>
